<template>
  <v-menu
    v-model="openPicker"
    content-class="menu-date-picker"
    min-width="auto"
    offset-y
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-bind="attrs"
        v-on="on"
        v-model="computedDateFormatted"
        dense
        hide-details
        label="Start date"
        prepend-inner-icon="mdi-calendar"
        outlined
        readonly
      />
    </template>
    <v-date-picker
      class="custom-date-picker"
      color="primary"
      next-icon="$vuetify.icons.chevron-right"
      prev-icon="$vuetify.icons.chevron-left"
      :value="value"
      @change="handleChange"
      @input="openPicker = false"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'BaseDatePicker',
  props: {
    value: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      openPicker: false,
    }
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.value)
    },
  },
  methods: {
    formatDate(date) {
      if (!date) {
        return null
      }

      const [year, , day] = date.split('-')
      const month = new Date(date).toLocaleString('en-US', { month: 'long' })
      return `${day} ${month} ${year}`
    },
    handleChange(v) {
      this.$emit('change', v)
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-date-picker {
  border-radius: 6px;
  box-shadow: var(--v-shadow-1);
}

::v-deep {
  .custom-date-picker {
    .v-date-picker-title__year {
      margin: 0;
      font-weight: 400;
      line-height: 24px;
    }

    .v-date-picker-title__date {
      padding: 0;
      font-weight: 400;
      font-size: 32px;
      line-height: 40px;
    }

    .v-date-picker-header__value {
      button {
        font-weight: 400;
        line-height: 24px;
      }
    }

    .v-icon__component {
      width: 14px;
      height: 14px;

      path {
        stroke: var(--v-grey-darken-1)
      }
    }
  }
}
</style>
